<template>
    <div>
        <input type="checkbox" name="linked" v-model="isLinked"> 
        <div v-if="isLinked && isChaptered()" class="options">
            <label for="chapters">Restrict chapter access (separate chapter numbers with commas). Leave blank to provide access to the entire ebook.</label>
            <input type="text" name="chapters" id="chapters" v-model="chapters">
        </div>
    </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
    name: "LinkOptions",
    props: {
        type: String,
        itemId: [String, Number]
    },
    created() {
        this.debouncedChapters = debounce(this.updateAccess, 500);
    },  
    computed: {
        chapters: {
            get() {
                const access = this.$store.state.selectedProductAccess;
                if (access[this.type]) {
                    console.log('found access of this type', this.type);
                    if (access[this.type][this.itemId]) {
                        console.log('found access for this itemid: ', this.itemId);
                        console.log("Chapters: ", JSON.stringify(access[this.type][this.itemId]));
                        return access[this.type][this.itemId]['chapters'];
                    }
                }
                console.log('Didn\'t find any applicable access');
                return '';
            },
            set(ch) {
                if (this.isLinked) {
                    this.debouncedChapters(this.isLinked, ch);
                }
            }
        },
        isLinked: {
            get() {
                const access = this.$store.state.selectedProductAccess;

                if (!access[this.type]) { 
                    console.warn("No access of this type " + this.type + "for the selected product: ", this.$store.state.selectedProductTitle);
                    return false;
                }

                console.log("getting linked state for: " + this.type + this.itemId + " where access is: ", access[this.type]);

                if (this.isChaptered()) {
                    if (access[this.type][this.itemId]) {
                        return true;
                    }
                } else {
                    return access[this.type].indexOf(this.itemId) !== -1;
                }

                return false;
            },
            set(isLinked){
                this.updateAccess(isLinked, this.chapters);
            }
        },
        
    },  
    methods: {
        updateAccess(isLinked, chapters) {
            let options = {
                type: this.type,
                itemId: this.itemId,
                isLinked,
                chapters
            };
            console.log('set link called with options: ', options);
            this.$store.dispatch("updateSelectedProductAccess", options);
        },
        isChaptered() {
            return (this.type == 'bid' || this.type == 'cid');
        }
    }
 
}
</script>

<style scoped>
    .options{
        font-size: 13px;
        padding-left: 10px;
        border-left: solid 5px #ddd;
        margin-left: 4px;
    }
</style>
